import React, { useContext, useEffect, useMemo, useState } from 'react';
/* eslint-disable */
import { Button, Checkbox, Col, DatePicker, Form, Input, Row, Select } from 'antd/es';
/* eslint-disable */
import { message, Radio, Spin } from 'antd';
/* eslint-disable */
import PropTypes from 'prop-types';
import moment from 'moment';
import { useForm } from 'antd/es/form/Form';
import FileSelect from '../../../../components/form/upload/SingleUpload';
import formCol from '../../../../utils/formCol';
import AloneCol from '../../../../components/common/AloneCol';
import select from '../../../../utils/select';
import form from '../../../../utils/form';
import file from '../../../../utils/file';
import EnrollmentService from '../../EnrollmentService';
import { EnrollmentContext } from '../../../../providers/EnrollmentContextProvider';
import { EnrollmentFormContext } from '../../../../providers/EnrollmentFormContextProvider';
import enrollmentAction from '../../../../providers/EnrollmentContextProvider/enrollmentAction';
import useParams from '../../../params/useParams';
import paramType from '../../../params/paramEndpoints';
import tokens from '../../../../utils/tokens';
import InputNumber from '../../../../components/form/inputs/InputNumber';
import { rutValidator } from '../../../../utils/validators';
import InputRut from '../../../../components/form/inputs/InputRut';
import InfoModal from '../../../../components/data-display/InfoModal';
import newCi from '../../../../assets/images/help/new CI.svg';
import oldCi from '../../../../assets/images/help/old CI.svg';
import Paragraph from '../../../../components/common/Paragraph';
import './styles.less';
import useLocalParam from '../../../params/useLocalParam';
import IdentificationType from '../../../../enums/identificationType';
import InfoLeyArt150 from './InfoLeyArt150';

const PersonalDocumentsStep = ({ onFinish }) => {
  const { dispatch, postulantRut, enrollmentId } = useContext(EnrollmentContext);
  const { enrollmentForm } = useContext(EnrollmentFormContext);
  const [isLoading, setLoading] = useState(false);
  const [executives, areExecutivesLoading] = useParams(paramType.EXECUTIVES);
  const [isMarried, setMarried] = useState(
    enrollmentForm.getFieldValue(['person', 'civilStatus']) === 'CASADO'
  );
  const [isFemale, setFemale] = useState(
    enrollmentForm.getFieldValue(['person', 'sex']) === 'FEMALE'
  );
  const [isPartner, setPartner] = useState(
    enrollmentForm.getFieldValue(['person', 'partner', 'patrimonialRegime']) === 'Soc. Conyugal'
  );
  const [showsPartnerAddress, setShowPartnerAddress] = useState(
    !enrollmentForm.getFieldValue(['person', 'partner', 'address', 'sameAsApplicant'] ?? true)
  );
  const [country, setCountry] = useState(
    enrollmentForm.getFieldValue(['person', 'address', 'country'])
  );
  const regionsPayload = useMemo(
    () => ({
      country,
    }),
    [country]
  );
  const [region, setRegion] = useState(
    enrollmentForm.getFieldValue(['person', 'address', 'region'])
  );
  const citiesPayload = useMemo(
    () => ({
      region,
    }),
    [region]
  );
  const [partnerCountry, setPartnerCountry] = useState(
    enrollmentForm.getFieldValue(['person', 'partner', 'address', 'country'])
  );
  const partnerRegionsPayload = useMemo(
    () => ({
      country: partnerCountry,
    }),
    [partnerCountry]
  );
  const [partnerRegion, setPartnerRegion] = useState(
    enrollmentForm.getFieldValue(['person', 'partner', 'address', 'region'])
  );
  const partnerCitiesPayload = useMemo(
    () => ({
      region: partnerRegion,
    }),
    [partnerRegion]
  );
  const [sexes, areSexesLoading] = useParams(paramType.SEXES);
  const [countries, areCountriesLoading] = useParams(paramType.COUNTRIES);
  const [regions, areRegionsLoading] = useLocalParam(paramType.REGIONS, regionsPayload);
  const [cities, areCitiesLoading] = useLocalParam(paramType.CITIES, citiesPayload);
  const [partnerRegions, arePartnerRegionsLoading] = useLocalParam(
    paramType.REGIONS,
    partnerRegionsPayload
  );
  const [partnerCities, arePartnerCitiesLoading] = useLocalParam(
    paramType.CITIES,
    partnerCitiesPayload
  );
  const [civilStatuses, areCivilStatusesLoading] = useParams(paramType.CIVIL_STATUSES);
  const [patrimonialRegimes, arePatrimonialRegimesLoading] = useParams(
    paramType.PATRIMONIAL_REGIMES
  );

  const [ciFrontFileList, setCiFrontFileList] = useState(
    enrollmentForm.getFieldValue(['person', 'ciFrontFileList'])
  );
  const [ciBackFileList, setCiBackFileList] = useState(
    enrollmentForm.getFieldValue(['person', 'ciBackFileList'])
  );
  const [partnerIdentificationType, setPartnerIdentificationType] = useState(
    enrollmentForm.getFieldValue(['person', 'partner', 'identificationType'])
  );
  const [documentsForm] = useForm();

  const handleSubmit = async (values) => {
    setLoading(true);

    const { ciFront, ciBack, executiveId, person, ...restValues } = values;
    const ciFrontBase64 = await file.toBase64(ciFront);
    const ciBackBase64 = await file.toBase64(ciBack);
    const documents = [];

    documents.push({
      typeKey: file.types.RUT_FRONT,
      base64: ciFrontBase64,
      filename: ciFront.name,
    });

    documents.push({
      typeKey: file.types.RUT_BACK,
      base64: ciBackBase64,
      filename: ciBack.name,
    });

    const payload = {
      ...restValues,
      executiveId: executiveId || null,
      documents,
      person: { ...person, dateOfBirth: moment(person.dateOfBirth) },
    };

    if (person.partner?.sameAsApplicant) {
      payload.person.partner = {
        ...person.partner,
        address: true,
      };
    }

    if (person.partner) {
      payload.person.partner = {
        ...person.partner,
        dateOfBirth: moment(person.partner.dateOfBirth),
      };

      if (person.partner.address) {
        payload.person.partner.address = person.address;
      }

      delete payload.person.partner.emailValidation;
    }

    EnrollmentService.updateEnrollment(payload, enrollmentId)
      .then(() => {
        dispatch({
          type: enrollmentAction.SET_STEP_DATA,
          payload: {
            ...values,
            ciFrontFileList,
            ciBackFileList,
          },
        });
        onFinish();
      })
      .catch(() => {
        message.error('Error inesperado. Por favor intente nuevamente.');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleCivilStatusChange = (value) => {
    setMarried(value === 'CASADO');
  };
  const handleSex = (value) => {
    setFemale(value === 'FEMALE');
  };

  const handlePatrimonialRegimeChange = (value) => {
    setPartner(value === 'Soc. Conyugal');
  };

  const handleCountrySelect = (value) => {
    setCountry(value);
    setRegion(undefined);
    documentsForm.setFieldsValue({
      region: undefined,
      city: undefined,
    });
  };

  const handleRegionSelect = (value) => {
    setRegion(value);
    documentsForm.setFieldsValue({
      city: undefined,
    });
  };

  const handlePartnerCountrySelect = (value) => {
    setPartnerCountry(value);
    setPartnerRegion(undefined);
    documentsForm.setFieldsValue({
      partner: { address: { region: undefined, city: undefined } },
    });
  };

  const handlePartnerRegionSelect = (value) => {
    setPartnerRegion(value);
    documentsForm.setFieldsValue({
      partner: { address: { city: undefined } },
    });
  };

  const handlePartnerIdentificationTypeChange = (event) => {
    setPartnerIdentificationType(event.target.value);
    documentsForm.setFieldsValue({
      partner: {
        identification: undefined,
      },
    });
  };

  const togglePartnerAddress = () => setShowPartnerAddress((value) => !value);

  const getPartnerIdentificationLabel = () => {
    switch (partnerIdentificationType) {
      case IdentificationType.RUT:
        return 'RUT';
      case IdentificationType.PASAPORTE:
        return 'Pasaporte';
      default:
        return 'RUT/Pasaporte';
    }
  };

  const partnerRutValidator = async (_, value) => {
    await rutValidator(_, value);
    if (value === postulantRut) {
      throw new Error('No puedes ingresar el mismo RUT del solicitante.');
    }
  };

  useEffect(() => {
    if (!showsPartnerAddress) {
      enrollmentForm.resetFields([
        ['person', 'partner', 'address', 'country'],
        ['person', 'partner', 'address', 'region'],
        ['person', 'partner', 'address', 'city'],
        ['person', 'partner', 'address', 'streetName'],
        ['person', 'partner', 'address', 'streetNumber'],
        ['person', 'partner', 'address', 'houseNumber'],
      ]);
    }
  }, [showsPartnerAddress]);

  return (
    <Spin spinning={isLoading}>
      <Row justify="center">
        <Col {...formCol.responsive}>
          <Form
            form={enrollmentForm}
            layout="vertical"
            onFinish={handleSubmit}
            validateMessages={form.validateMessages}
            scrollToFirstError={{ behavior: 'smooth', block: 'center' }}
          >
            <Form.Item
              name="executiveId"
              label="Ejecutivo de contacto VanTrust"
              rules={[{ required: true }]}
            >
              <Select
                showSearch
                filterOption={select.filterOptions.searchByLabel}
                placeholder="Seleccionar"
                loading={areExecutivesLoading}
              >
                {!areExecutivesLoading && (
                  <Select.Option value={0}>No tengo ejecutivo asignado</Select.Option>
                )}
                {executives.map((executive) => (
                  <Select.Option key={executive.id} value={executive.id}>
                    {executive.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <p>
              <b>Datos personales</b>
            </p>
            <Row gutter={tokens.forms.horizontalGutterInPx}>
              <AloneCol span={12}>
                <Form.Item name={['person', 'sex']} label="Sexo" rules={[{ required: true }]}>
                  <Select onChange={handleSex} placeholder="Seleccionar" loading={areSexesLoading}>
                    {sexes.map(({ id, name }) => (
                      <Select.Option key={id} value={id}>
                        {name}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </AloneCol>
              <AloneCol span={12}>
                <Form.Item
                  name={['person', 'nationality']}
                  label="Nacionalidad"
                  rules={[{ required: true }]}
                >
                  <Select placeholder="Seleccionar" loading={areCountriesLoading}>
                    {countries.map(({ id, name }) => (
                      <Select.Option key={id} value={id}>
                        {name}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </AloneCol>
              <AloneCol span={12}>
                <Form.Item
                  label="Fecha de nacimiento"
                  name={['person', 'dateOfBirth']}
                  required
                  rules={[{ required: true }]}
                >
                  <DatePicker
                    defaultPickerValue={form.date.defaultValue.yearsAgo(30)}
                    showToday={false}
                    disabledDate={form.date.dateDisablers.minAge(10)}
                    format={form.date.format.day}
                    style={{ width: '100%' }}
                    autoComplete="cc-csc"
                  />
                </Form.Item>
              </AloneCol>
              <Col span={12}>
                <Form.Item
                  name={['person', 'serialNumber']}
                  label="Número de Documento de CI"
                  rules={[{ required: true, min: 9 }]}
                  normalize={form.normalizers.alphanumericUpperCase}
                >
                  <Input type="text" placeholder="435224266" maxLength={12} autoComplete="cc-csc" />
                </Form.Item>
              </Col>
              <Col span={12}>
                <div style={{ marginTop: '1.6rem' }}>
                  <InfoModal
                    buttonLabel="¿Dónde encuentro mi número de documento/serie?"
                    footer={null}
                    width={700}
                    buttonProps={{
                      block: true,
                      style: {
                        whiteSpace: 'normal',
                        textAlign: 'left',
                      },
                    }}
                  >
                    <Paragraph size="lg" align="center">
                      ¿Dónde encuentro mi número de documento/serie?
                    </Paragraph>
                    <Row gutter={30} justify="center">
                      <Col xs={12} sm={10}>
                        <img src={oldCi} alt="carnet antiguo" style={{ width: '100%' }} />
                        <Paragraph noBottomMargin align="center" style={{ marginTop: '1rem' }}>
                          Cédula de Identidad Antigua
                        </Paragraph>
                      </Col>
                      <Col xs={12} sm={10}>
                        <img src={newCi} alt="carnet nuevo" style={{ width: '100%' }} />
                        <Paragraph noBottomMargin align="center" style={{ marginTop: '1rem' }}>
                          Cédula de Identidad Nueva
                        </Paragraph>
                      </Col>
                    </Row>
                  </InfoModal>
                </div>
              </Col>
            </Row>
            <p>
              <b>Domicilio particular</b>
            </p>
            <Row gutter={tokens.forms.horizontalGutterInPx}>
              <Col span={12}>
                <Form.Item
                  name={['person', 'address', 'country']}
                  label="País"
                  rules={[{ required: true }]}
                >
                  <Select
                    placeholder="Seleccionar"
                    loading={areCountriesLoading}
                    filterOption={select.filterOptions.searchByLabel}
                    onChange={handleCountrySelect}
                  >
                    {countries.map(({ id, name }) => (
                      <Select.Option key={id} value={id}>
                        {name}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name={['person', 'address', 'region']}
                  label="Región"
                  rules={[
                    {
                      required: country && regions.length > 0,
                    },
                  ]}
                >
                  <Select
                    placeholder="Seleccionar"
                    loading={areRegionsLoading}
                    onChange={handleRegionSelect}
                    disabled={!country || regions.length === 0}
                  >
                    {regions.map(({ id, name }) => (
                      <Select.Option key={id} value={id}>
                        {name}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  name={['person', 'address', 'city']}
                  label="Comuna"
                  rules={[
                    {
                      required: region && cities.length > 0,
                    },
                  ]}
                >
                  <Select
                    placeholder="Seleccionar"
                    loading={areCitiesLoading}
                    disabled={!region || regions.length === 0}
                  >
                    {cities.map(({ id, name }) => (
                      <Select.Option key={id} value={id}>
                        {name}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={17}>
                <Form.Item
                  name={['person', 'address', 'streetName']}
                  label="Calle/Avenida"
                  rules={[{ required: true }]}
                >
                  <Input maxLength={32} autoComplete="off" />
                </Form.Item>
              </Col>
              <Col span={7}>
                <Form.Item
                  name={['person', 'address', 'streetNumber']}
                  label="Número"
                  rules={[{ required: true }]}
                >
                  <InputNumber hideArrows maxLength={8} autoComplete="off" />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item name={['person', 'address', 'houseNumber']} label="Departamento / Casa">
                  <Input maxLength={10} autoComplete="off" />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={tokens.forms.horizontalGutterInPx}>
              <Col span={12}>
                <Form.Item
                  name={['person', 'civilStatus']}
                  label="Estado Civil"
                  rules={[{ required: true }]}
                >
                  <Select
                    placeholder="Seleccionar"
                    onChange={handleCivilStatusChange}
                    loading={areCivilStatusesLoading}
                  >
                    {civilStatuses.map(({ id, name }) => (
                      <Select.Option key={id} value={id}>
                        {name}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              {isMarried && (
                <>
                  <Col span={12}>
                    <Form.Item
                      name={['person', 'partner', 'patrimonialRegime']}
                      label="Régimen Patrimonial"
                      rules={[{ required: true }]}
                    >
                      <Select
                        placeholder="Seleccionar"
                        loading={arePatrimonialRegimesLoading}
                        onChange={handlePatrimonialRegimeChange}
                      >
                        {patrimonialRegimes.map(({ name, id }) => (
                          <Select.Option key={id} value={id}>
                            {name}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  {isPartner && isFemale && (
                    <Col lg={24}>
                      <Form.Item
                        label={
                          <div className="personalDocumentStep__title">
                            ¿Las inversiones que efectuará provienen de su patrimonio reservado en
                            conformidad a lo establecido en el
                            <InfoLeyArt150 />{' '}
                          </div>
                        }
                        name={['person', 'inversionsFollowArticle150']}
                        rules={[{ required: true }]}
                      >
                        <Radio.Group
                          options={[
                            { label: 'Si', value: true },
                            { label: 'No', value: false },
                          ]}
                        />
                      </Form.Item>
                    </Col>
                  )}
                  <Col span={24}>
                    <p>
                      <b>Cónyugue o conviviente civil</b>
                    </p>
                  </Col>
                  <AloneCol span={12}>
                    <Form.Item
                      name={['person', 'partner', 'name']}
                      label="Nombre"
                      rules={[{ required: true }]}
                    >
                      <Input maxLength={64} />
                    </Form.Item>
                  </AloneCol>
                  <Col span={12}>
                    <Form.Item
                      name={['person', 'partner', 'firstSurname']}
                      label="Apellido Paterno"
                      rules={[{ required: true }]}
                    >
                      <Input type="text" maxLength={25} />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      name={['person', 'partner', 'secondSurname']}
                      label="Apellido Materno"
                      rules={[{ required: false }]}
                    >
                      <Input type="text" maxLength={25} />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      name={['person', 'partner', 'identificationType']}
                      label="Tipo de identificación"
                      rules={[{ required: true }]}
                    >
                      <Radio.Group onChange={handlePartnerIdentificationTypeChange}>
                        <Radio value={IdentificationType.RUT}>RUT</Radio>
                        <Radio value={IdentificationType.PASAPORTE}>Pasaporte</Radio>
                      </Radio.Group>
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      name={['person', 'partner', 'identification']}
                      label={getPartnerIdentificationLabel()}
                      rules={[
                        {
                          required: true,
                          min: partnerIdentificationType === IdentificationType.RUT ? 11 : 6,
                          validator:
                            partnerIdentificationType === IdentificationType.RUT
                              ? partnerRutValidator
                              : undefined,
                        },
                      ]}
                    >
                      {partnerIdentificationType === IdentificationType.RUT ? (
                        <InputRut maxLength={12} />
                      ) : (
                        <Input maxLength={24} disabled={!partnerIdentificationType} />
                      )}
                    </Form.Item>
                  </Col>
                  <AloneCol span={12}>
                    <Form.Item
                      name={['person', 'partner', 'nationality']}
                      label="Nacionalidad"
                      rules={[{ required: true }]}
                    >
                      <Select placeholder="Seleccionar" loading={areCountriesLoading}>
                        {countries.map(({ id, name }) => (
                          <Select.Option key={id} value={id}>
                            {name}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </AloneCol>
                  <AloneCol span={12}>
                    <Form.Item
                      label="Fecha de nacimiento"
                      name={['person', 'partner', 'dateOfBirth']}
                      required
                      rules={[{ required: true }]}
                    >
                      <DatePicker
                        defaultPickerValue={form.date.defaultValue.yearsAgo(30)}
                        showToday={false}
                        disabledDate={form.date.dateDisablers.minAge(10)}
                        format={form.date.format.day}
                        style={{ width: '100%' }}
                      />
                    </Form.Item>
                  </AloneCol>
                  <AloneCol span={12}>
                    <Form.Item
                      name={['person', 'partner', 'sex']}
                      label="Sexo"
                      rules={[{ required: true }]}
                    >
                      <Select placeholder="Seleccionar" loading={areSexesLoading}>
                        {sexes.map(({ id, name }) => (
                          <Select.Option key={id} value={id}>
                            {name}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </AloneCol>
                  <Col span={12}>
                    <Form.Item
                      name={['person', 'partner', 'email']}
                      label="E-mail"
                      rules={[{ required: true, type: 'email' }]}
                    >
                      <Input
                        type="email"
                        maxLength={64}
                        onBlur={(e) => {
                          const trimmedValue = e.target.value.trim();
                          e.target.value = trimmedValue;
                          enrollmentForm.setFieldsValue({
                            person: {
                              partner: {
                                email: trimmedValue,
                              },
                            },
                          });
                        }}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      name={['person', 'partner', 'emailValidation']}
                      label="Reescriba su E-mail"
                      validateTrigger="onBlur"
                      rules={[
                        {
                          required: true,
                          message: 'Email es requerido',
                        },
                        ({ getFieldValue }) => ({
                          validator(_, value) {
                            if (!value || getFieldValue('person').partner.email === value) {
                              return Promise.resolve();
                            }
                            return Promise.reject(
                              new Error('Email no es igual al primero digitado')
                            );
                          },
                        }),
                      ]}
                    >
                      <Input
                        type="email"
                        maxLength={64}
                        {...form.inputProps.noPaste}
                        onBlur={(e) => {
                          const trimmedValue = e.target.value.trim();
                          e.target.value = trimmedValue;
                          enrollmentForm.setFieldsValue({
                            person: {
                              partner: {
                                emailValidation: trimmedValue,
                              },
                            },
                          });
                        }}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      name={['person', 'partner', 'phone']}
                      label="Teléfono Móvil"
                      rules={[
                        {
                          required: true,
                          len: 9,
                        },
                      ]}
                      normalize={form.normalizers.numeric}
                    >
                      <Input type="text" maxLength={9} />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      name={['person', 'partner', 'phoneAlt']}
                      label="Teléfono Fijo (opcional)"
                      rules={[
                        {
                          len: 9,
                        },
                      ]}
                      normalize={form.normalizers.numeric}
                    >
                      <Input type="text" maxLength={9} />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <p>
                      <b>Domicilio de cónyugue</b>
                    </p>
                  </Col>
                  <Col span={24}>
                    <Form.Item
                      name={['person', 'partner', 'address', 'sameAsApplicant']}
                      valuePropName="checked"
                      preserve
                    >
                      <Checkbox onChange={togglePartnerAddress}>
                        Usar mismo domicilio particular
                      </Checkbox>
                    </Form.Item>
                  </Col>
                  {showsPartnerAddress && (
                    <>
                      <Col span={12}>
                        <Form.Item
                          name={['person', 'partner', 'address', 'country']}
                          label="País"
                          rules={[{ required: true }]}
                        >
                          <Select
                            placeholder="Seleccionar"
                            loading={areCountriesLoading}
                            onChange={handlePartnerCountrySelect}
                          >
                            {countries.map(({ id, name }) => (
                              <Select.Option key={id} value={id}>
                                {name}
                              </Select.Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col span={12}>
                        <Form.Item
                          name={['person', 'partner', 'address', 'region']}
                          label="Región"
                          rules={[
                            {
                              required: partnerCountry && partnerRegions.length > 0,
                            },
                          ]}
                        >
                          <Select
                            placeholder="Seleccionar"
                            loading={arePartnerRegionsLoading}
                            onChange={handlePartnerRegionSelect}
                            disabled={!partnerCountry || partnerRegions.length === 0}
                          >
                            {partnerRegions.map(({ id, name }) => (
                              <Select.Option key={id} value={id}>
                                {name}
                              </Select.Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col span={24}>
                        <Form.Item
                          name={['person', 'partner', 'address', 'city']}
                          label="Comuna"
                          rules={[
                            {
                              required: partnerRegion && partnerCities.length > 0,
                            },
                          ]}
                        >
                          <Select
                            placeholder="Seleccionar"
                            loading={arePartnerCitiesLoading}
                            disabled={!partnerRegion || partnerCities.length === 0}
                          >
                            {partnerCities.map(({ id, name }) => (
                              <Select.Option key={id} value={id}>
                                {name}
                              </Select.Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col span={17}>
                        <Form.Item
                          name={['person', 'partner', 'address', 'streetName']}
                          label="Calle/Avenida"
                          rules={[{ required: true }]}
                        >
                          <Input maxLength={32} autoComplete="off" />
                        </Form.Item>
                      </Col>
                      <Col span={7}>
                        <Form.Item
                          name={['person', 'partner', 'address', 'streetNumber']}
                          label="Número"
                          rules={[{ required: true }]}
                        >
                          <InputNumber hideArrows maxLength={8} autoComplete="off" />
                        </Form.Item>
                      </Col>
                      <Col span={12}>
                        <Form.Item
                          name={['person', 'partner', 'address', 'houseNumber']}
                          label="Departamento / Casa"
                        >
                          <Input maxLength={12} autoComplete="off" />
                        </Form.Item>
                      </Col>
                    </>
                  )}
                </>
              )}
            </Row>
            <p>
              <b>Registro de documentos</b>
            </p>
            <Row gutter={tokens.forms.horizontalGutterInPx}>
              <Col span={24}>
                <p style={{ marginBottom: 0 }}>
                  <b>Sube las imágenes de tu Cédula de Identidad por ambos lados</b>
                </p>
                <p>Archivos JPG, PNG, o PDF - Tamaño máximo 10MB.</p>
              </Col>
              <Col span={24}>
                <Form.Item name="ciFront" rules={[{ required: true }]}>
                  <FileSelect
                    accept={'image/*,.pdf'}
                    maxSizeKb={10240}
                    defaultFileList={ciFrontFileList}
                    onFileListChange={setCiFrontFileList}
                  >
                    Subir imagen frontal de CI
                  </FileSelect>
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item name="ciBack" rules={[{ required: true }]}>
                  <FileSelect
                    accept={'image/*,.pdf'}
                    maxSizeKb={10240}
                    defaultFileList={ciBackFileList}
                    onFileListChange={setCiBackFileList}
                  >
                    Subir imagen posterior de CI
                  </FileSelect>
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item>
                  <Button type="primary" htmlType="submit" block>
                    Siguiente
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>
    </Spin>
  );
};

PersonalDocumentsStep.propTypes = {
  onFinish: PropTypes.func.isRequired,
};

export default PersonalDocumentsStep;
